import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* istanbul ignore file */
import React, { useState } from 'react';
import { useAppSelector } from '../../hooks/useAppSelector';
import Recurly from '../Recurly/Recurly';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { modeSelector } from '../../redux/AppModeState/AppModeState.selectors';
import { sendRioEvent, SharedCommandNames, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import { doFireStatusUpdate } from '../../utils/CallbackUtils';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { Processors } from '../../constants/AppConstants';
import { Component } from '../../constants/CallbackConstants';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import { PaymentFormView } from '../Recurly/PaymentFormView';
import AccordionMopListView from '../../internals/Recurly/MopListView/MopListView';
import LoadingIndicator from '../LoadingIndicator';
import { PaymentTopHeader, PaymentOptionsContainer } from '../PaymentViews/styled';
import { HiddenHeader } from '../HiddenHeader';
import MessageBox from '../MessageBox/MessageBox';
import UseGetRecurlyMop from '../../hooks/useGetRecurlyMop';
import { getString } from '../../constants/Strings';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { mopOnFileSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
var InitializeRecurly = function InitializeRecurly(_) {
  var config = useAppSelector(configSelector);
  var mode = useAppSelector(modeSelector);
  var _useAppSelector = useAppSelector(mopOnFileSelector),
    hasLoadedMops = _useAppSelector.hasLoadedMops,
    paymentMethods = _useAppSelector.paymentMethods;
  var hasMops = hasLoadedMops && paymentMethods.length;
  var headingText = config.headingText,
    initialHeadingLevel = config.initialHeadingLevel,
    paymentProcessors = config.paymentProcessors,
    priceSummary = config.priceSummary,
    showHeading = config.showHeading,
    rioNamespace = config.rioNamespace,
    appConstants = config.appConstants;
  var _ref = appConstants,
    recurly = _ref.recurly;
  var isRecurlyEnabled = paymentProcessors.indexOf(Processors.RECURLY) > -1;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    service = _useState2[0],
    setService = _useState2[1];
  UseGetRecurlyMop();
  var callback = function callback(recurlyService) {
    setService(recurlyService);
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.PM_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: SharedCommandNames.INITIALIZE,
      payload: {
        component: Component.PAYMENT_OPTIONS
      }
    }]);
  };
  var getPaymentViewsBody = function getPaymentViewsBody() {
    return /*#__PURE__*/React.createElement(PaymentOptionsContainer, {
      tabIndex: -1,
      "data-test": DataTestAttributes.PAYMENT_OPTIONS
    }, showHeading && headingText && /*#__PURE__*/React.createElement(PaymentTopHeader, {
      "data-test": DataTestAttributes.PAYMENT_FORM_HEADER,
      "aria-level": initialHeadingLevel
    }, headingText), /*#__PURE__*/React.createElement(HiddenHeader, {
      mode: mode
    }), /*#__PURE__*/React.createElement(MessageBox, null), (mode === AppMode.DEFAULT_MOP || mode === AppMode.LIST_MOPS) && /*#__PURE__*/React.createElement(AccordionMopListView, {
      mode: mode
    }), (mode === AppMode.ADD || !hasMops) && /*#__PURE__*/React.createElement(PaymentFormView, null));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isRecurlyEnabled && /*#__PURE__*/React.createElement(Recurly, {
    callback: callback
  }), service && priceSummary && mode !== AppMode.LOADING ? /*#__PURE__*/React.createElement(RecurlyProvider, {
    publicKey: recurly.publicKey,
    required: ['cvv']
  }, /*#__PURE__*/React.createElement(Elements, null, getPaymentViewsBody())) : /*#__PURE__*/React.createElement(LoadingIndicator, null));
};
export default /*#__PURE__*/React.memo(InitializeRecurly);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/InitializeRecurly/index.js
// module id = 4604
// module chunks = 11